// utils/navigateToLogin.js
export const redirectToLogin = () => {
        window.location.href = '/login'; // Or use a custom login path
};
